import { animationType } from './animations';

export type CursorImageProps = {
  animation: AnimatedCursorProps['animation'];
};

export type CursorLabelProps = {
  size: number;
};

export type CursorContainerProps = {
  size: number;
};

export interface RefObject<T> {
  // immutable
  readonly current: T | null;
}
export enum CursorPositions {
  CENTER = 'center',
  UPPER_LEFT = 'upperLeft',
  UPPER_RIGHT = 'upperRight',
  LOWER_LEFT = 'lowerLeft',
  LOWER_RIGHT = 'lowerRight',
}

export type AnimationType = (typeof animationType)[keyof typeof animationType];

export type AnimatedCursorProps = {
  image?: string;
  size?: number;
  visible?: boolean;
  rotation?: number;
  animation?: AnimationType;
  elementsWithAnimatedCursor?: string;
  position?: CursorPositions;
  label?: string;
  waiting?: boolean;
  shouldUpdate?: boolean;
  setDomUpdate?: (arg: boolean) => void;
};
